import { ConditionalWrapperPropsType } from '@/models/globalModels';

/*used to conditionally render any wrapper element
to avoid code duplication. example: an image wrapped by a link*/
const ConditionalWrapper = ({ wrapper, children, condition }: ConditionalWrapperPropsType) => (condition ? wrapper(children) : children);

export default ConditionalWrapper;
